import React, { Component } from 'react';
import ApiHeadersCreatorComponent from './ApiHeadersCreatorComponent';
import ApiHeadersListComponent from './ApiHeadersListComponent';

class ApiHeadersComponent extends Component {
  public render() {
    return (
      <div className={'flex flex-col w-full h-full mt-4'}>
        <ApiHeadersCreatorComponent />
        <ApiHeadersListComponent />
      </div>
    );
  }
}

export default ApiHeadersComponent;
